













import { Component, Prop, Vue } from 'vue-property-decorator';
import Chapter from '@/interfaces/models/Chapter';
import Flow from '@/interfaces/models/Flow';
import Slide from '@/interfaces/models/Slide';

@Component
export default class PresentationItem extends Vue {
  @Prop({ type: String, required: true }) name!: string;
  @Prop({ type: String }) image!: string;
  @Prop({ type: Boolean }) stacked!: boolean;
}
